<div
  role="tabpanel"
  *ngIf="tabActive$ | async as tab"
  [attr.aria-labelledby]="'tab-button-' + tab.id"
  id="shrd-uic-tab-content-{{ tab.contentReference }}"
>
  <ng-content></ng-content>
</div>
